export const SET_COTATION = "SET_COTATION";
export const REINIT_COTATION = "REINIT_COTATION";
export const FILL_COTATION = "FILL_COTATION";
export const SET_MENU_FILTER = "SET_MENU_FILTER";
export const SET_FILTER_S_F = "SET_FILTER_S_F";
export const REINIT_S_F = "REINIT_S_F";
